import React from 'react';

export const DecorSvg1: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="364.413"
        height="416.797"
        viewBox="0 0 364.413 416.797"
        {...props}
    >
        <path
            d="M134.844-53.748c74.335,0,134.346,119.961,134.346,216.826S209.18,297.031,134.844,297.031,0,259.943,0,163.078,60.509-53.748,134.844-53.748Z"
            transform="matrix(0.951, -0.309, 0.309, 0.951, 16.609, 134.303)"
            fill="#57bbb0"
        />
    </svg>
);

export const DecorSvg2: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="214.547"
        height="237.081"
        viewBox="0 0 214.547 237.081"
        {...props}
    >
        <g transform="matrix(0.883, 0.469, -0.469, 0.883, -90.498, -338.531)">
            <path
                d="M445.516,223.581l18.849,34.3L409.479,405.014l-18.849-34.3Z"
                transform="translate(0 0)"
                fill="#f37e8e"
            />
            <path
                d="M390.63,370.714l18.849,34.3-72.785-9.172-18.849-34.3Z"
                transform="translate(0 0)"
                fill="#e8596c"
            />
            <path
                d="M445.516,223.581,390.63,370.714l-72.785-9.172,54.886-147.133Z"
                transform="translate(0 0)"
                fill="#ff8f9d"
            />
        </g>
    </svg>
);

export const DecorSvg3: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="398.022"
    height="398.022"
    viewBox="0 0 398.022 398.022"
    {...props}
  >
    <path
      d="M239.792-115.373c109.911,0,158.23,147.008,158.23,256.919s-48.319,141.1-158.23,141.1S0,251.457,0,141.546,129.881-115.373,239.792-115.373Z"
      transform="translate(0 115.373)"
      fill="#ffcf6e"
    />
  </svg>
);

export const DecorSvg4: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="169.001"
    height="170.958"
    viewBox="0 0 169.001 170.958"
    {...props}
  >
    <g transform="matrix(0.574, -0.819, 0.819, 0.574, -123.665, 155.862)">
      <path
        d="M162.551,154.88l-7.967-34.3L187.9,71.117l7.967,34.3,7.968,34.3-33.314,49.468Z"
        transform="translate(36.237 0)"
        fill="#e8596c"
      />
      <path
        d="M114.038,117.912l110.1-46.8-33.314,49.468Z"
        transform="translate(0 0)"
        fill="#ff8f9d"
      />
      <path
        d="M114.038,95.827,206.756,167.1l-7.968-34.3-7.967-34.3Z"
        transform="translate(0 22.084)"
        fill="#f37e8e"
      />
    </g>
  </svg>
);

export const DecorSvg5: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="59"
    height="59"
    viewBox="0 0 59 59"
    {...props}
  >
    <circle cx="29.5" cy="29.5" r="29.5" fill="#57bbb0" />
  </svg>
);

export const DecorSvg6: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="81.88"
    height="72.761"
    viewBox="0 0 81.88 72.761"
    {...props}
  >
    <g style={{ isolation: "isolate" }}>
      <g transform="translate(0)">
        <path
          d="M361.619,263.966l-31.814-7.158L301.093,288.92l31.814,7.158Z"
          transform="translate(-301.093 -256.808)"
          fill="#ffab15"
        />
      </g>
      <g transform="translate(0 32.111)">
        <path
          d="M340.349,296.451l-31.814-7.158,21.355,33.492,31.814,7.158Z"
          transform="translate(-308.535 -289.293)"
          fill="#ff9400"
        />
      </g>
      <g transform="translate(31.814 7.158)">
        <path
          d="M329.557,297.541,308.2,264.049,279.49,296.161l21.355,33.492Z"
          transform="translate(-279.49 -264.049)"
          fill="#ffdc40"
        />
      </g>
    </g>
  </svg>
);

export const DecorSvg7: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46.969"
    height="53.357"
    viewBox="0 0 46.969 53.357"
    {...props}
  >
    <g
      transform="translate(0 45.498) rotate(-79)"
      style={{ isolation: "isolate" }}
    >
      <g transform="translate(0 18.959)">
        <path
          d="M34.261,18.178,16.253,22.23,0,4.052,18.009,0Z"
          fill="#ffab15"
        />
      </g>
      <g transform="translate(0 0)">
        <path
          d="M18.009,18.959,0,23.011,12.088,4.052,30.1,0Z"
          fill="#ff9400"
        />
      </g>
      <g transform="translate(18.009 0)">
        <path
          d="M28.341,18.178,16.253,37.136,0,18.959,12.088,0Z"
          fill="#ffdc40"
        />
      </g>
    </g>
  </svg>
);


export const DecorSvg8: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    {...props}
  >
    <circle cx="14" cy="14" r="14" fill="#ff6c9e" />
  </svg>
);



export const ServiceSectionDecor4: React.FC<
  React.SVGProps<SVGSVGElement>
> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="128.347"
    height="114.053"
    viewBox="0 0 128.347 114.053"
    {...props}
  >
    <g style={{ isolation: "isolate" }}>
      <g transform="translate(33.474)">
        <path
          d="M301.093,268.028l49.868-11.22,45.005,50.335L346.1,318.363Z"
          transform="translate(-301.093 -256.808)"
          fill="#ffab15"
        />
      </g>
      <g transform="translate(45.006 50.335)">
        <path
          d="M342.009,300.513l49.868-11.22-33.474,52.5-49.868,11.22Z"
          transform="translate(-308.535 -289.293)"
          fill="#ff9400"
        />
      </g>
      <g transform="translate(0 11.22)">
        <path
          d="M279.49,316.547l33.474-52.5,45.006,50.335-33.474,52.5Z"
          transform="translate(-279.49 -264.049)"
          fill="#ffdc40"
        />
      </g>
    </g>
  </svg>
);


export const ServiceSectionDecor3: React.FC<
  React.SVGProps<SVGSVGElement>
> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="479.608"
    height="472.937"
    viewBox="0 0 479.608 472.937"
    {...props}
  >
    <path
      d="M309.293,78.012c91.761,0,23,53.626,23,171.637s-40.34,151.5-132.1,151.5S0,367.66,0,249.649,217.532,78.012,309.293,78.012Z"
      transform="matrix(0.799, -0.602, 0.602, 0.799, -46.949, 152.563)"
      fill="#ffcbde"
    />
  </svg>
);


export const ServiceSectionDecor2: React.FC<
  React.SVGProps<SVGSVGElement>
> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="169.001"
    height="170.958"
    viewBox="0 0 169.001 170.958"
    {...props}
  >
    <g transform="matrix(0.574, -0.819, 0.819, 0.574, -123.665, 155.862)">
      <path
        d="M162.551,154.88l-7.967-34.3L187.9,71.117l7.967,34.3,7.968,34.3-33.314,49.468Z"
        transform="translate(36.237 0)"
        fill="#e8596c"
      />
      <path
        d="M114.038,117.912l110.1-46.8-33.314,49.468Z"
        transform="translate(0 0)"
        fill="#ff8f9d"
      />
      <path
        d="M114.038,95.827,206.756,167.1l-7.968-34.3-7.967-34.3Z"
        transform="translate(0 22.084)"
        fill="#f37e8e"
      />
    </g>
  </svg>
);


export const ServiceSectionDecor1: React.FC<
  React.SVGProps<SVGSVGElement>
> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="381.261"
    height="389.118"
    viewBox="0 0 381.261 389.118"
    {...props}
  >
    <g transform="translate(501.381 73.106) rotate(132)">
      <path
        d="M164.008,65.2a133.2,133.2,0,0,1,133.2,133.2c0,73.565-17.884,118.422-91.449,118.422S0,232.931,0,159.366,90.443,65.2,164.008,65.2Z"
        transform="translate(84.28 262.843) rotate(-80)"
        fill="#ff6c9e"
      />
    </g>
  </svg>
);






export default DecorSvg1;
